<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner></app-custom-spinner>
</div>
<app-breadcrumb></app-breadcrumb>

<div class="esign-doc-banner d-flex align-items-center gap-3 mb-2 px-3 py-2">
  <i class="fa fa-file-text-o" style="font-size:22px;color:#0056b3;"></i>
  <div class="flex-grow-1">
    <span class="fw-bold" style="font-size:13px;">{{ documentData.documentName }}</span>
    <span class="ms-2 text-muted" style="font-size:11px;">
      {{ documentData.documentName  }} | v-{{ documentData.version }}
      <span class="badge bg-secondary ms-1">{{ documentData.documentExtn | uppercase }}</span>
    </span>
  </div>
  <span *ngIf="envelopeSent"
    style="background:#d4edda;color:#155724;border:1px solid #c3e6cb;
           border-radius:20px;padding:3px 12px;font-size:11px;font-weight:700;">
    <i class="fa fa-check-circle"></i> Sent for Signing
  </span>
</div>

<div *ngIf="!envelopeSent">

  <div class="esign-field-toolbar d-flex flex-wrap align-items-center gap-2 mb-2 px-2 py-2">
    <span style="font-size:11px;font-weight:700;color:#495057;">Add Field:</span>
    <button class="esign-field-btn signature-btn"
      [class.active-tool]="isPlacingField&&selectedFieldType==='signature'"
      (click)="setFieldType('signature')">
      <i class="fa fa-pencil-square-o"></i> Signature
    </button>
    <button class="esign-field-btn date-btn"
      [class.active-tool]="isPlacingField&&selectedFieldType==='date'"
      (click)="setFieldType('date')">
      <i class="fa fa-calendar"></i> Date
    </button>
    <button class="esign-field-btn initials-btn"
      [class.active-tool]="isPlacingField&&selectedFieldType==='initials'"
      (click)="setFieldType('initials')">
      <i class="fa fa-font"></i> Initials
    </button>
    <button class="esign-field-btn text-field-btn"
      [class.active-tool]="isPlacingField&&selectedFieldType==='text'"
      (click)="setFieldType('text')">
      <i class="fa fa-align-left"></i> Text
    </button>
    <button class="esign-field-btn redact-btn"
      [class.active-tool]="isPlacingField&&selectedFieldType==='redact'"
      title="Permanently blacks out area"
      (click)="setFieldType('redact')">
      <i class="fa fa-eraser"></i> Redact
    </button>
    <div class="ms-auto d-flex align-items-center gap-2">
      <span class="text-danger" style="font-size:11px;" *ngIf="isPlacingField">
        <i class="fa fa-crosshairs"></i>
        Click document to place <strong>{{ selectedFieldType }}</strong>
        &nbsp;<span style="cursor:pointer;text-decoration:underline;color:#6c757d;"
          (click)="isPlacingField=false">cancel</span>
      </span>
      <button class="esign-field-btn danger-btn" *ngIf="selectedField&&!isPlacingField"
        (click)="deleteSelectedField()">
        <i class="fa fa-trash"></i> Delete
      </button>
    </div>
  </div>

  <div class="row g-2">

    <div class="col-md-9">
      <div style="border:1px solid #dee2e6;border-radius:6px;overflow:hidden;background:#525659;">

        <div *ngIf="isProcessing"
          style="height:68vh;display:flex;align-items:center;justify-content:center;">
          <div class="text-center text-white">
            <i class="fa fa-spinner fa-spin" style="font-size:36px;"></i>
            <p class="mt-2">Loading document...</p>
          </div>
        </div>

        <div *ngIf="!isProcessing && pdfDoc"
          style="overflow:auto;max-height:68vh;display:flex;justify-content:center;
                 align-items:flex-start;padding:10px 0;background:#525659;">

          <div style="position:relative;display:inline-block;flex-shrink:0;background:#fff;" (mousedown)="deselectField()">

            <canvas #pdfCanvas style="display:block;border:none;outline:none;"></canvas>

            <div *ngIf="isPlacingField"
              style="position:absolute;top:0;left:0;right:0;bottom:0;
                     z-index:200;cursor:crosshair;background:rgba(0,86,179,0.04);"
              (mousedown)="$event.stopPropagation(); onPlacementCapture($event)">
            </div>

            <div #fieldOverlay
              style="position:absolute;top:0;left:0;right:0;bottom:0;
                     z-index:50;pointer-events:none;">

              <div *ngFor="let f of pageFields; trackBy: trackByFieldId"
                #chipRef
                class="esign-chip"
                [ngClass]="[getChipClass(f.type), f===selectedField?'selected':'']"
                [style.left.%]="f.x"
                [style.top.%]="f.y"
                [style.width.%]="f.w"
                [style.height.%]="f.h"
                style="cursor:grab;"
                (mouseenter)="registerChipEl(f.fieldId, chipRef)"
                (mousedown)="$event.stopPropagation(); onChipMouseDown($event,f)">

                <span class="chip-label">
                  <i class="fa" style="margin-right:2px;"
                    [ngClass]="{'fa-pencil-square-o':f.type==='signature','fa-calendar':f.type==='date',
                                 'fa-font':f.type==='initials','fa-align-left':f.type==='text',
                                 'fa-eraser':f.type==='redact'}"></i>
                  {{ chipLabel(f) }}
                </span>

                <ng-container *ngIf="f===selectedField">
                  <div class="rh rh-nw" (mousedown)="$event.stopPropagation(); onResizeStart($event,f,'nw')"></div>
                  <div class="rh rh-ne" (mousedown)="$event.stopPropagation(); onResizeStart($event,f,'ne')"></div>
                  <div class="rh rh-sw" (mousedown)="$event.stopPropagation(); onResizeStart($event,f,'sw')"></div>
                  <div class="rh rh-se" (mousedown)="$event.stopPropagation(); onResizeStart($event,f,'se')"></div>
                  <div class="rh rh-n"  (mousedown)="$event.stopPropagation(); onResizeStart($event,f,'n')"></div>
                  <div class="rh rh-s"  (mousedown)="$event.stopPropagation(); onResizeStart($event,f,'s')"></div>
                  <div class="rh rh-w"  (mousedown)="$event.stopPropagation(); onResizeStart($event,f,'w')"></div>
                  <div class="rh rh-e"  (mousedown)="$event.stopPropagation(); onResizeStart($event,f,'e')"></div>
                </ng-container>
              </div>

            </div></div></div><div *ngIf="!isProcessing && pdfLoadError"
          style="height:68vh;display:flex;flex-direction:column;align-items:center;
                 justify-content:center;color:#ffc107;padding:30px;text-align:center;"
          [style.cursor]="isPlacingField?'crosshair':'default'"
          (mousedown)="onViewerClick($event)">
          <i class="fa fa-file-text-o" style="font-size:48px;opacity:0.5;"></i>
          <p class="mt-2" style="font-size:12px;max-width:400px;">{{ pdfLoadErrorMsg }}</p>
        </div>

        <div *ngIf="!isProcessing && !pdfDoc && !pdfLoadError"
          style="height:68vh;display:flex;align-items:center;justify-content:center;color:#ccc;">
          <div class="text-center">
            <i class="fa fa-file-o" style="font-size:40px;opacity:0.3;"></i>
            <p class="mt-2">Preparing viewer...</p>
          </div>
        </div>

        <div *ngIf="pdfDoc && totalPages > 1"
          class="d-flex align-items-center justify-content-center gap-3 py-2"
          style="background:#333;border-top:1px solid #555;">
          <button class="addIconContiner px-3 py-1" style="cursor:pointer;"
            (click)="prevPage()" [disabled]="currentPage===1">
            <i class="fa fa-chevron-left text-white"></i>
          </button>
          <span style="font-size:12px;color:#fff;">
            Page {{ currentPage }} of {{ totalPages }}
          </span>
          <button class="addIconContiner px-3 py-1" style="cursor:pointer;"
            (click)="nextPage()" [disabled]="currentPage===totalPages">
            <i class="fa fa-chevron-right text-white"></i>
          </button>
        </div>

      </div>
    </div><div class="col-md-3">
      <div class="esign-panel" style="height:100%;display:flex;flex-direction:column;">
        <div class="esign-panel-title">
          <i class="fa fa-list-ul"></i> Fields & Assignment
          <span class="badge bg-primary ms-1" style="font-size:10px;">{{ fields.length }}</span>
        </div>

        <div *ngIf="fields.length>0&&userDropdownList.length>0" style="padding:4px 6px;border-bottom:1px solid #dee2e6;">
          <input type="text" class="layer-search" placeholder="Search user..." [(ngModel)]="userSearchTxt" />
        </div>

        <div style="flex:1;overflow-y:auto;padding:4px;">
          <div *ngFor="let f of fields; trackBy: trackByFieldId" class="field-item" [class.selected]="f===selectedField" (click)="selectField(f)">
            <div class="d-flex align-items-center justify-content-between mb-1">
              <span class="field-badge" [ngClass]="getFieldBadgeClass(f.type)" style="font-size:9px;">{{ f.type | uppercase }}</span>
              <span style="font-size:10px;color:#888;">Pg{{ f.pageNo }}</span>
              <i class="fa fa-trash" style="color:#dc3545;cursor:pointer;font-size:10px;" (click)="removeField(f.fieldId,$event)"></i>
            </div>

            <div *ngIf="f.type!=='redact'" class="d-flex align-items-start gap-1 mt-1">
              <select class="form-select form-select-sm" style="font-size:10px;padding:2px 4px;width:55px;cursor:pointer;"
                [(ngModel)]="f.layerNo" (ngModelChange)="onLayerChange(f, $event)">
                <option [ngValue]="1">L1</option>
                <option [ngValue]="2">L2</option>
                <option [ngValue]="3">L3</option>
                <option [ngValue]="4">L4</option>
              </select>
              <div class="flex-grow-1">
                <select class="form-select form-select-sm" style="font-size:10px;padding:2px 4px;cursor:pointer;"
                  [ngModel]="f.assignedUserId" (ngModelChange)="assignUserToField(f, $event)">
                  <option [ngValue]="null">Choose signer</option>
                  <option *ngFor="let u of filteredUserDropdownList; trackBy: trackByUserId" [ngValue]="u.valueExp">
                    {{ u.displayExp }}
                  </option>
                </select>
                <div style="font-size:9px;margin-top:2px;" [style.color]="f.assignedUserId ? '#28a745' : '#dc3545'">
                  <i class="fa" [class.fa-check]="f.assignedUserId" [class.fa-warning]="!f.assignedUserId"></i>
                  {{ f.assignedUserId ? f.assignedUserName : 'Unassigned' }}
                </div>
              </div>
            </div>
            <div *ngIf="f.type==='redact'" style="font-size:9px;color:#666;margin-top:2px;">
              <i class="fa fa-lock"></i> No signer needed
            </div>
          </div>

          <div *ngIf="fields.length===0" class="text-center text-muted py-4" style="font-size:11px;">
            <i class="fa fa-arrow-up d-block mb-1"></i>
            Use toolbar to place fields
          </div>
        </div>

        <div style="border-top:1px solid #dee2e6;padding:5px 8px;font-size:10px;color:#6c757d;">
          <div>Sig fields: <strong>{{ sigFieldCount }}</strong></div>
          <div *ngIf="redactCount">Redact: <strong>{{ redactCount }}</strong></div>
          <div *ngIf="totalPages>1">Page {{ currentPage }}/{{ totalPages }}</div>
          <ng-container *ngIf="sigFieldCount>0">
            <div *ngIf="hasUnassignedFields" style="color:#dc3545;margin-top:2px;font-size:9px;">
              <i class="fa fa-warning"></i> Some fields unassigned
            </div>
          </ng-container>
        </div>

        <div *ngIf="signingOrderSummary.length > 0" style="border-top:1px solid #dee2e6;padding:8px;background:#fafafa;">
          <div style="font-size:10px;font-weight:700;color:#495057;margin-bottom:6px;">
            <i class="fa fa-sort-numeric-asc"></i> Derived Signing Order
          </div>
          <div *ngFor="let s of signingOrderSummary; let i=index">
            <div class="d-flex align-items-center gap-2">
              <div class="layer-badge" style="width:16px;height:16px;font-size:9px;">{{ s.layerNo }}</div>
              <div style="font-size:10px;color:#0056b3;font-weight:600;">{{ s.userName }}</div>
            </div>
            <div *ngIf="i < signingOrderSummary.length - 1" style="color:#6c757d;font-size:10px;margin-left:5px;padding:2px 0;">
              <i class="fa fa-arrow-down"></i>
            </div>
          </div>
        </div>

        <div style="border-top:1px solid #dee2e6;padding:8px;">
          <label style="font-size:10px;font-weight:600;color:#495057;">
            Envelope Title <span class="mandatory-symbol">*</span>
          </label>
          <input class="input-filed-continers mb-1" type="text" style="font-size:11px;" placeholder="e.g. SOP-101 Approval" [ngModel]="envelopeTitle" (ngModelChange)="onTitleChange($event)" />
          <div *ngIf="sendBlockReason" style="font-size:10px;color:#dc3545;margin-bottom:4px;">
            <i class="fa fa-warning"></i> {{ sendBlockReason }}
          </div>
          <div class="d-flex gap-2">
            <button mat-stroked-button class="cancelButton" style="font-size:11px;flex:1;" (click)="goBack()">
              <i class="fa fa-close"></i> Cancel
            </button>
            <div class="addIconContiner d-flex gap-1 align-items-center justify-content-center" style="flex:1;cursor:pointer;"
              [style.opacity]="canSend?'1':'0.5'" [title]="sendBlockReason||'Send for Signature'" (click)="createAndSendEnvelope()">
              <i class="fa fa-paper-plane text-white" style="font-size:11px;"></i>
              <span class="reload_text text-white" style="font-size:11px;">Send</span>
            </div>
          </div>
        </div>

      </div>
    </div></div></div><div *ngIf="envelopeSent">
  <div class="sent-banner mb-3">
    <i class="fa fa-check-circle" style="font-size:32px;color:#28a745;"></i>
    <h5 class="mt-2 mb-1">Signing Request Active</h5>
    <p style="font-size:12px;margin:0;">Signers are being notified in sequence. No changes can be made.</p>
  </div>

  <div class="row g-3" *ngIf="sentEnvelopeData">
    <div class="col-md-4">
      <div class="esign-panel">
        <div class="esign-panel-title"><i class="fa fa-info-circle"></i> Details</div>
        <div class="px-3 py-2" style="font-size:12px;">
          <div class="row mb-1"><div class="col-5 text-muted">Title</div><div class="col-7 fw-bold">{{ sentEnvelopeData.envelopeTitle }}</div></div>
          <div class="row mb-1">
            <div class="col-5 text-muted">Status</div>
            <div class="col-7">
              <span class="badge"
                [class.bg-success]="['Completed'].includes(sentEnvelopeData.envelopeStatus||sentEnvelopeData.status)"
                [class.bg-warning]="['Sent','InProgress'].includes(sentEnvelopeData.envelopeStatus||sentEnvelopeData.status)"
                [class.bg-danger]="['Cancelled'].includes(sentEnvelopeData.envelopeStatus||sentEnvelopeData.status)"
                [class.bg-secondary]="['Draft'].includes(sentEnvelopeData.envelopeStatus||sentEnvelopeData.status)">
                {{ sentEnvelopeData.envelopeStatus || sentEnvelopeData.status }}
              </span>
            </div>
          </div>
          <div class="row mb-1"><div class="col-5 text-muted">Layers</div><div class="col-7">{{ sentEnvelopeData.totalLayers }}</div></div>
          <div class="row mb-1"><div class="col-5 text-muted">Current</div><div class="col-7">Layer {{ sentEnvelopeData.currentLayer }}</div></div>
          <div class="row" *ngIf="sentEnvelopeData.completedOn">
            <div class="col-5 text-muted">Completed</div>
            <div class="col-7">{{ sentEnvelopeData.completedOn | date:'dd-MMM-yyyy' }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-5">
      <div class="esign-panel">
        <div class="esign-panel-title"><i class="fa fa-tasks"></i> Signing Progress</div>
        <div class="px-2 py-2">
          <div *ngFor="let signer of sentEnvelopeData.signers; let i=index" style="margin-bottom:3px;">
            <div style="border:1px solid #e9ecef;border-radius:5px;padding:7px 10px;"
              [style.border-color]="signer.status==='Signed'?'#28a745':signer.status==='Declined'?'#dc3545':'#dee2e6'"
              [style.background]="signer.status==='Signed'?'#f0fff4':'#fff'">
              <div class="d-flex align-items-center gap-2">
                <div class="layer-badge" style="width:20px;height:20px;font-size:10px;">{{ signer.layerNo }}</div>
                <div style="flex:1;font-size:11px;font-weight:600;">{{ signer.userFullName||signer.userName||signer.signedName||'Unknown Signer' }}
</div>
                <span style="font-size:11px;"
                  [class.text-success]="signer.status==='Signed'"
                  [class.text-warning]="signer.status==='OPEN'||signer.status==='Pending'"
                  [class.text-danger]="signer.status==='Declined'">
                  <i class="fa" [class.fa-check-circle]="signer.status==='Signed'"
                    [class.fa-clock-o]="signer.status==='OPEN'||signer.status==='Pending'"
                    [class.fa-times-circle]="signer.status==='Declined'"></i>
                  {{ signer.status === 'OPEN' ? 'Pending' : signer.status }}
                </span>
              </div>
            </div>
            <div *ngIf="i<sentEnvelopeData.signers?.length-1" class="text-center" style="color:#6c757d;font-size:12px;padding:1px;">
              <i class="fa fa-arrow-down"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3">
      <div class="esign-panel">
        <div class="esign-panel-title"><i class="fa fa-map-marker"></i> Fields</div>
        <div class="px-2 py-2">
          <div *ngFor="let f of sentEnvelopeData.fieldMetadata | jsonParse"
            class="d-flex align-items-center gap-2 mb-1"
            style="padding:3px 5px;border:1px solid #e9ecef;border-radius:3px;">
            <span class="field-badge" [ngClass]="getFieldBadgeClass(f.type)" style="font-size:9px;">{{ f.type | uppercase }}</span>
            <span style="font-size:10px;color:#666;">Pg.{{ f.pageNo }}<span *ngIf="f.type!=='redact'">· L{{ f.layerNo }}</span></span>
            <span *ngIf="f.assignedUserName" style="font-size:9px;color:#0056b3;margin-left:auto;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:60px;">
              {{ f.assignedUserName }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-3">
    <button mat-stroked-button class="cancelButton" (click)="goBack()">
      <i class="fa fa-arrow-left"></i> Back to Documents
    </button>
  </div>
</div>